module.exports = __webpack_public_path__ + "static/media/proj1_img15.0bacedc9.jpg";